import { apiOrigin } from '../utils/surface';

const SEAM_PROXY = `${apiOrigin()}/seam`;

export async function createConnectWebview(options?: { accepted_providers?: string[]; custom_redirect_url?: string }) {
  const res = await fetch(`${SEAM_PROXY}/connect_webviews/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ provider_category: 'stable', wait_for_device_creation: true, ...options }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to create connect webview');
  return data.connect_webview;
}

export async function getConnectWebview(connectWebviewId: string) {
  const res = await fetch(`${SEAM_PROXY}/connect_webviews/get?connect_webview_id=${encodeURIComponent(connectWebviewId)}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to get connect webview');
  return data.connect_webview;
}

export async function listSeamDevices(connectedAccountId: string) {
  const res = await fetch(`${SEAM_PROXY}/devices/list`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ connected_account_id: connectedAccountId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to list devices');
  return data.devices || [];
}

export async function getSeamDevice(deviceId: string) {
  const res = await fetch(`${SEAM_PROXY}/devices/get`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: deviceId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to get device');
  return data.device;
}

export async function lockSeamDevice(deviceId: string) {
  const res = await fetch(`${SEAM_PROXY}/locks/lock`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: deviceId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to lock device');
  return data;
}

export async function unlockSeamDevice(deviceId: string) {
  const res = await fetch(`${SEAM_PROXY}/locks/unlock`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: deviceId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to unlock device');
  return data;
}

export async function listAccessCodes(deviceId: string) {
  const res = await fetch(`${SEAM_PROXY}/access_codes/list`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: deviceId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to list access codes');
  return data.access_codes || [];
}

export async function createAccessCode(deviceId: string, name: string, code?: string, startsAt?: string, endsAt?: string) {
  const body: any = { device_id: deviceId, name };
  if (code) body.code = code;
  if (startsAt && endsAt) {
    body.type = 'time_bound';
    body.starts_at = startsAt;
    body.ends_at = endsAt;
  }
  const res = await fetch(`${SEAM_PROXY}/access_codes/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to create access code');
  return data.access_code;
}

export async function updateAccessCode(accessCodeId: string, updates: { name?: string; code?: string; starts_at?: string; ends_at?: string }) {
  const res = await fetch(`${SEAM_PROXY}/access_codes/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ access_code_id: accessCodeId, ...updates }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to update access code');
  return data;
}

export async function deleteAccessCode(accessCodeId: string) {
  const res = await fetch(`${SEAM_PROXY}/access_codes/delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ access_code_id: accessCodeId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to delete access code');
  return data;
}

export async function listLockEvents(deviceId: string, limit = 50) {
  const res = await fetch(`${SEAM_PROXY}/events/list`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: deviceId, limit }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to list events');
  return data.events || [];
}
